import classNames from 'classnames';
import React from 'react';

import { network, WidgetProps } from '../config';

interface Props extends WidgetProps {
  className?: string;
  title: string;
}

// https://docs.manifold.xyz/v/manifold-for-developers/resources/widgets/marketplace-widgets/widgets/listing-widgets#m-listing-countdown
export const Countdown = ({ className, listingId, title }: Props) => {
  return (
    <div className={classNames('flex items-center gap-1', className)}>
      <span>{title}</span>
      <div
        data-id={listingId}
        data-network={network}
        data-widget="m-listing-countdown"
      />
    </div>
  );
};
